import {
  Container,
  Grid,
  useMediaQuery,
  useTheme,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Locations } from "./context";
import { ILocation } from "./models";
import { getLocations, getProviders } from "./fetch";

import { FindALocationMap } from "./pages";
import { AllLocations } from "./pages/AllLocations";
import {} from "@material-ui/core";

function App() {
  const theme = useTheme();
  const classes = useStyles();
  const removeGutters = useMediaQuery(theme.breakpoints.down("md"));

  const [officeLocations, setOfficeLocations] = useState<ILocation[]>([]);

  useEffect(() => {
    try {
      getLocations().then((locations) => {
        try {
          getProviders().then((providers) => {
            const num_pages = providers.headers["x-wp-totalpages"];
            let allProviders = providers.data;
            if (num_pages > 1) {
              for (let i = 2; i <= num_pages; i++) {
                // eslint-disable-next-line no-loop-func
                getProviders(i).then((nth_providers) => {
                  allProviders = allProviders.concat(nth_providers.data);
                });
              }
            }
            setOfficeLocations(
              locations.data
                .map((location: any) => {
                  return {
                    id: location.id,
                    name: `${location.title.rendered}`,
                    address: `${location.acf.address} ${
                      location.acf.address2 && location.acf.address2
                    } ${location.acf.city}, ${location.acf.state} ${
                      location.acf.zip
                    }`,
                    hours: location.acf.center_hours,
                    dental_hours: location.acf.dental_hours,
                    pharmacy_hours: location.acf.pharmacy_hours,
                    lat: location.acf.google_map.lat,
                    lng: location.acf.google_map.lng,
                    phone: location.acf.phone,
                    dental_fax: location.acf.dental_fax,
                    family_practice_fax: location.acf.family_practice_fax,
                    pediatrics_fax: location.acf.pediatrics_fax,
                    pharmacy_fax: location.acf.pharmacy_fax,
                    womens_health_fax: location.acf.womens_health_fax,
                    fax: location.acf.fax,
                    services: location.acf.services,
                    providers: providers.data.filter((provider) => {
                      if (typeof provider.acf.locations !== "boolean") {
                        for (
                          let i = 0;
                          i < provider.acf.locations.length;
                          i++
                        ) {
                          return provider.acf.locations[i].ID === location.id;
                        }
                      }
                      return false;
                    }),
                    link: location.link,
                  };
                })
                .sort((a, b) => {
                  if (a.name < b.name) {
                    return -1;
                  }
                  if (a.name > b.name) {
                    return 1;
                  }
                  return 0;
                })
            );
          });
        } catch (e) {
          console.error(e);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }, []);

  return (
    <Locations.Provider value={officeLocations}>
      <Container
        disableGutters={removeGutters}
        className={classes.container}
        maxWidth={"lg"}
      >
        <Grid container>
          <Grid item xs={12}>
            <BrowserRouter>
              <Switch>
                <Route
                  exact
                  path="/find-a-location"
                  component={FindALocationMap}
                />
                <Route exact path="/services" component={FindALocationMap} />
                <Route exact path="/locations" component={AllLocations} />
                <Route component={FindALocationMap} />
              </Switch>
            </BrowserRouter>
          </Grid>
        </Grid>
      </Container>
    </Locations.Provider>
  );
}
export default App;

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginBottom: "5rem",
  },
}));
